export default {
  TEACHER_SELECT: 'TEACHER_SELECT',
  TEACHER_DEFAULT_SELECTIONS: 'TEACHER_DEFAULT_SELECTIONS',
  TEACHER_CUSTOM_BENCHMARKS_COMPLETE: 'TEACHER_CUSTOM_BENCHMARKS_COMPLETE',
  TEACHER_CUSTOM_BENCHMARKS_PENDING: 'TEACHER_CUSTOM_BENCHMARKS_PENDING',
  SET_TEACHER_SELECT_STATE: 'SET_TEACHER_SELECT_STATE',
}